module.exports = __webpack_public_path__ + "static/media/tour-rec-blueGrey.65f1d381.svg";